export const blackish = "#000000";
export const whiteish = "#F8F8F8";
